module.exports = __webpack_public_path__ + "static/childhood-cancer-mobile.d0128024.webp";